(function () {
  function scrollToNotifyForm() {
    var root = document.getElementById('NrBackInStockNotify');
    if (!root) return;
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var emailInput = root.querySelector('input[type="email"]');
    if (emailInput) {
      window.setTimeout(function () {
        emailInput.focus({ preventScroll: true });
      }, 350);
    }
  }

  function initForm(form) {
    if (!form || form.dataset.nrBisBound === 'true') return;
    form.dataset.nrBisBound = 'true';

    var submitButton = form.querySelector('[data-nr-bis-submit]');
    var emailInput = form.querySelector('input[type="email"]');
    var successBanner = form.querySelector('[data-nr-bis-success]');
    var errorBanner = form.querySelector('[data-nr-bis-error]');
    var submitUrl = form.dataset.nrSubmitUrl || '';
    var successMessage =
      form.dataset.nrSuccessMessage || "You're on the list — we'll email you when it's back.";
    var errorMessage = form.dataset.nrErrorMessage || 'Something went wrong. Please try again.';

    function showBanner(banner, message) {
      if (!banner) return;
      banner.textContent = message;
      banner.hidden = false;
    }

    function hideBanners() {
      if (successBanner) successBanner.hidden = true;
      if (errorBanner) errorBanner.hidden = true;
    }

    async function handleSubmit() {
      hideBanners();

      if (emailInput && !emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      var payload = {
        email: form.querySelector('[name="email"]')?.value.trim() || '',
        product_title: form.querySelector('[name="product_title"]')?.value.trim() || '',
        product_handle: form.querySelector('[name="product_handle"]')?.value.trim() || '',
        variant_id: form.querySelector('[name="variant_id"]')?.value.trim() || '',
        variant_title: form.querySelector('[name="variant_title"]')?.value.trim() || '',
        website: form.querySelector('[name="website"]')?.value.trim() || '',
      };

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting…';
      }

      try {
        var response = await fetch(submitUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        var data = await response.json().catch(function () {
          return {};
        });

        if (!response.ok || !data.ok) {
          throw new Error(data.error || errorMessage);
        }

        showBanner(successBanner, successMessage);
        if (emailInput) emailInput.value = '';
      } catch (error) {
        showBanner(errorBanner, error.message || errorMessage);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.defaultLabel || 'Notify me';
        }
      }
    }

    if (submitButton) {
      submitButton.addEventListener('click', handleSubmit);
      if (!submitButton.dataset.defaultLabel) {
        submitButton.dataset.defaultLabel = submitButton.textContent.trim();
      }
    }

    if (emailInput) {
      emailInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        event.stopPropagation();
        handleSubmit();
      });
    }
  }

  function initAllForms() {
    document.querySelectorAll('[data-nr-bis-form]').forEach(function (form) {
      initForm(form);
    });
  }

  function syncVariantFields(event) {
    var variant = event.detail && event.detail.resource;
    var html = event.detail && event.detail.data && event.detail.data.html;
    if (!html) return;

    var sticky = document.querySelector('sticky-add-to-cart');
    var newSticky = html.querySelector('sticky-add-to-cart');
    if (sticky && newSticky) {
      if (newSticky.hasAttribute('data-nr-bis-mode')) {
        sticky.setAttribute('data-nr-bis-mode', newSticky.getAttribute('data-nr-bis-mode'));
      } else {
        sticky.removeAttribute('data-nr-bis-mode');
      }
    }

    var productForm = document.querySelector('product-form-component');
    if (!productForm) return;
    if (event.detail.data.productId !== productForm.dataset.productId) return;

    var currentButtons = productForm.querySelector('.product-form-buttons');
    var newButtons = html.querySelector('.product-form-buttons');
    if (!currentButtons || !newButtons) return;

    var hadNotify = !!currentButtons.querySelector('[data-nr-bis-notify]');
    var hasNotify = !!newButtons.querySelector('[data-nr-bis-notify]');

    if (hadNotify !== hasNotify || hasNotify) {
      currentButtons.replaceWith(newButtons.cloneNode(true));
      initAllForms();
      return;
    }

    if (!variant) return;

    var notifyRoot = document.querySelector('[data-nr-bis-notify]');
    if (!notifyRoot) return;

    var variantIdInput = notifyRoot.querySelector('[data-nr-bis-variant-id]');
    var variantTitleInput = notifyRoot.querySelector('[data-nr-bis-variant-title]');
    if (variantIdInput && variant.id) {
      variantIdInput.value = String(variant.id);
    }
    if (variantTitleInput) {
      variantTitleInput.value = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var sticky = event.target.closest('sticky-add-to-cart[data-nr-bis-mode="sold-out"]');
      if (!sticky) return;
      var button = event.target.closest('.sticky-add-to-cart__button');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToNotifyForm();
    },
    true
  );

  document.addEventListener('variant:update', syncVariantFields);
  document.addEventListener('shopify:section:load', initAllForms);

  initAllForms();
})();
